<template>
  <div class="message_appear_box">
    <router-view></router-view>
  </div>
</template>
<script>
import { defineComponent, getCurrentInstance, onBeforeMount } from "vue";
import { useRoute } from 'vue-router'
import { useStore } from 'vuex';
const easyearn = window.easyearn;
function normalizeOpenId(value) {
  if (Array.isArray(value)) {
    return value.map(normalizeOpenId).find(Boolean) || '';
  }
  if (value === undefined || value === null) return '';
  const v = String(value).trim();
  return v && v !== 'undefined' && v !== 'null' ? v : '';
}
export default defineComponent({
  setup() {
    let route = useRoute();
    let store = useStore();
    onBeforeMount(() => {
      console.log(route.query, 'route--main');
      setTimeout(() => {
        console.log(route.query, 'route--main2')
      }, 3000);
      // console.log(route.query, 'routessssssssss');
      // console.log(localStorage.getItem('data'), 'data');
      if (route.query.type == 'h5page') {
        if(route.query && route.query.urlcome) {
          store.commit('SET_fullpath', route.query.urlcome)
          store.commit('SET_search', route.query.search)
          store.commit('SET_reportSearchWX', route.query.reportSearchWX)
        }
        if(route.query.newPoi) {
          store.commit('SET_newPoi', route.query.newPoi)
        }
        if(route.query.uu) {
          store.commit('SET_islattest', true)
        }
        store.dispatch('SETIsH5', true)
        store.commit('SET_page', route.query.page)
        store.commit('SET_userPhone', route.query.userPhone)
        store.commit('setlocation', route.query.location)
        const openId = normalizeOpenId(route.query.openId || route.query.openid || route.query.opid)
        if (openId) {
          store.commit('setuserOpenId', openId)
          try { localStorage.setItem('userOpenId', openId) } catch (e) { /* ignore */ }
        } else {
          console.warn('[voiceReport] route.query 未携带有效 openId，保留现有 userOpenId', route.query)
        }
        store.dispatch('SETisStaff', route.query.isStaff)
        store.dispatch('setMiniProgramShare', route.query.miniProgramShare)
        if (route.query.token) {
          store.dispatch('setAccessToken', route.query.token)
        }
        if (route.query.refer) {
          store.dispatch('setRefreshToken', route.query.refer)
        }
      } else {
        store.dispatch('SETIsH5', false)
        store.dispatch('SETisStaff', false)
        store.commit('setuserOpenId', store.state.userInfo.split('/')[0])
      }
    });
    const { beacon } = getCurrentInstance().appContext.config.globalProperties;
    beacon.onUserAction("homepage_show_report");
    const back = () => {
      easyearn && easyearn.goBack();
    };
    return {
      route,
      back
    };
  }
});
</script>
<style lang='scss' scoped>
.message_appear_box {
 
  background: #FAFAFC;
}
button,
input {
  outline: none;
}
// 暂时加的
.navBar {
  //   position: fixed;
  //   top: 0;
  width: 100%;
  z-index: 3;
  padding: 35px 0 11px;
  background-color: #fff;
  box-shadow: 0 2px 14px 0 rgba(0, 136, 255, 0.06);
  .navBarImg {
    position: absolute;
    width: 20px;
    height: 20px;
    left: 20px;
    line-height: 20px;
  }
  .navBarTitle {
    font-size: 16px;
    line-height: 20px;
    font-weight: Bold;
    text-align: center;
  }
}
</style>
